module.exports = __webpack_public_path__ + "static/media/status_2.04415293.svg";